/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const MinusCircleIconConfig = {
  name: 'MinusCircleIcon',
  height: 512,
  width: 512,
  svgPath: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(MinusCircleIconConfig);